import {GUID} from "../../shared/models/GUID-interface";

export class Focus{
    constructor(
        public param: string, public direction: string
    ){

    }
}

export class FocusGUID implements GUID{
    constructor(public GUID: string, public focus: Focus){

    }
}



// WEBPACK FOOTER //
// ./src/app/stocks/models/focus.ts